export default __webpack_public_path__ + "static/media/colorectal1.f973b4e0.jpg";